import styled from 'styled-components';
import { s } from './VIPReport.style';
import { IReportData } from '../../../service/quant/Quant';

const BasicInformation = ({ data }: { data?: IReportData['info'] }) => {
  return (
    <s.Div>
      <s.Title>🔎기본 정보 요약</s.Title>
      <s.Table>
        <s.TableHeader>
          <s.Header width="160px">항목</s.Header>
          <s.Header width="calc(100% - 160px)">금액</s.Header>
        </s.TableHeader>
        <s.Row>
          <RowLeft>감정가</RowLeft>
          <RowRight>
            {data?.appraisalPrc ? data?.appraisalPrc.toLocaleString() : '-'} 원
          </RowRight>
        </s.Row>
        <s.Row>
          <RowLeft>최저 입찰가</RowLeft>
          <RowRight>
            {data?.minPrc ? data?.minPrc.toLocaleString() : '-'} 원
          </RowRight>
        </s.Row>
        <s.Row>
          <RowLeft>예상 낙찰가</RowLeft>
          <RowRight>
            {data?.bidPrc ? data?.bidPrc.toLocaleString() : '-'} 원
          </RowRight>
        </s.Row>
        <s.Row>
          <RowLeft>AI 추정시세</RowLeft>
          <RowRight>
            {data?.aiPrc ? data?.aiPrc.toLocaleString() : '-'} 원
          </RowRight>
        </s.Row>
      </s.Table>
      <s.BottomDescription>
        <div>
          이 물건은{' '}
          {data?.appraisalPrc && data?.bidPrc
            ? '감정가보다 ' +
              (data.appraisalPrc > data.bidPrc ? '낮게' : '높게') +
              ' 낙찰이 예상되며,'
            : ''}
          {data?.appraisalPrc && data?.bidPrc && <br />}
          {data?.aiPrc && data.bidPrc ? (
            <span>
              시세 대비{' '}
              <span style={{ color: '#008AFF' }}>
                {data.aiPrc > data.bidPrc ? '▼' : '▲'} 약{' '}
                {data.aiPrc > data.bidPrc
                  ? Math.floor((1 - data.bidPrc / data.aiPrc) * 100)
                  : Math.floor((1 - data.aiPrc / data.bidPrc) * 100)}
                % {data.aiPrc > data.bidPrc ? '저렴' : '비싸'}
              </span>
              {data.aiPrc > data.bidPrc ? '하게' : '게'} 매입 가능성이 있습니다.
            </span>
          ) : (
            ''
          )}
          {data?.minPrc > data?.bidPrc ? (
            <div style={{ wordBreak: 'keep-all', marginTop: '6px' }}>
              해당 물건은 AI 분석 결과, 예상 낙찰가가 최저 입찰가보다 낮게
              분석됩니다.
              <br />
              <span>
                금번 회차보다{' '}
                <span style={{ color: '#008AFF' }}>
                  다음 회차에서 입찰을 추천
                </span>
                합니다.
              </span>
            </div>
          ) : (
            ''
          )}
        </div>
      </s.BottomDescription>
    </s.Div>
  );
};

export default BasicInformation;

const RowLeft = styled.div`
  width: 160px;
  padding: 16px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: start;
  font-size: 14px;
  font-weight: 500;
  color: #222222;
`;

const RowRight = styled.div`
  width: calc(100% - 160px);
  padding: 16px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: end;
  font-size: 14px;
  font-weight: 500;
  color: #222222;
`;
